import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getKiosksPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/reseni/kiosky",
		[Locale.en]: "/solutions/kiosks",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
